import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const updateKbCategory = createAsyncThunk(
  'kbCategory/updateKbCategory',
  async ({ categoryId, name, parentId, visibility, order, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const body = {
        name,
        visibility,
        group_id,
        ...(parentId && { parentId }),
        ...(order !== undefined && { order }),
      };

      const patchResponse = await axios.patch(
        `${BASE_URL}/trustchat-backend-service/v1/kb/category/${categoryId}`,
        body,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      // Fetch the updated category after successful update
      const getResponse = await axios.get(
        `${BASE_URL}/trustchat-backend-service/v1/kb/category/${categoryId}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          },
          params: { business_id, ...(group_id && { group_id }) }
        }
      );

      return {
        message: patchResponse.data.message || 'Category updated successfully.',
        data: getResponse.data
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const updateKbCategorySlice = createSlice({
  name: 'updateKbCategory',
  initialState,
  reducers: {
    resetUpdateKbCategoryState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateKbCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(updateKbCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload.data;
        toast.success(action.payload.message);
      })
      .addCase(updateKbCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message || 'Failed to update category.');
      });
  }
});

export const { resetUpdateKbCategoryState } = updateKbCategorySlice.actions;
export default updateKbCategorySlice.reducer;